// extracted by mini-css-extract-plugin
module.exports = {"empty_state":"F8Ff5A","emptyState":"F8Ff5A","title":"o_wkxn"};